<!--
 * @Author: wsx
 * @Date: 2022-02-23 17:00:48
 * @LastEditTime: 2022-02-11 17:52:34
 * @LastEditors: Please set LastEditors
 * @Description: 展示图片
 * @FilePath: \smart-community\src\components\global\HPicture.vue
-->
<template>
  <div
    class="HPicture"
    :style="pictureStyle"
    ref="pictureRef"
    v-for="(item, index) in data"
    :key="item.value"
  >
    <el-checkbox @click.native="handleChecked($event, item)"></el-checkbox>
    <i class="iconfont icon-guanbi2" @click="handleDelete(item, index)" />
    <img :style="pictureStyle" :src="item.url" />
    <div class="type">{{ item.type }}</div>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watchEffect,
  watch,
  ref,
  onMounted,
} from "vue";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "HPicture",
  components: {},
  props: {
    //图片大小
    pictureStyle: {
      type: Object,
      default: () => {
        return {
          width: "80px",
          height: "65px",
        };
      },
    },
    //上传一张照片后是否隐藏上传图标
    fileUrl: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const state = reactive({
      checked: true,
      checkedData: [],
    });

    const refData = toRefs(state);
    const pictureRef = ref();
    watchEffect(() => {
      console.log(props.data);
    });
    //删除图片，返回图片url
    const handleDelete = (file, index) => {
      props.data.splice(index, 1);
      if (state.checkedData.length !== 0) {
        state.checkedData = state.checkedData.filter((item) => {
          return item.value !== file.value;
        });
        emit("handleChecked", state.checkedData);
      }
      emit("handleDelete", props.data);
    };
    //选择图片，返回图片url
    const handleChecked = (e, file) => {
      if (e.target.tagName === "INPUT") return;
      if (state.checkedData.length == 0) {
        state.checkedData.push(file);
      } else {
        let result = state.checkedData.find((element) => {
          return element.value == file.value;
        });
        if (!result) {
          state.checkedData.push(file);
        } else {
          state.checkedData = state.checkedData.filter((item) => {
            return item.value !== file.value;
          });
        }
      }
      emit("handleChecked", state.checkedData);
    };
    //选择图片，返回图片url
    // const featureBase64 = (val) => {
    //   return "data:image/jpeg;base64,/9j/" + val;
    // };
    return {
      ...refData,
      pictureRef,
      handleDelete,
      handleChecked,
      // featureBase64,
    };
  },
});
</script>
<style lang="scss" scoped>
.HPicture {
  position: relative;
  margin: 10px 8px;
  .el-checkbox {
    position: absolute;
    top: 7px;
    height: 0px;
    left: 0px;
    cursor: pointer;
  }
  i {
    font-size: 14px;
    position: absolute;
    right: -10px;
    color: red;
    top: -10px;
    cursor: pointer;
  }
  img {
    border: 1px solid;
  }
  .type {
    text-align: center;
    font-size: 14px;
    width: 100%;
  }
}
</style>
